import { render, staticRenderFns } from "./sub_task.vue?vue&type=template&id=4e517223&"
import script from "./sub_task.vue?vue&type=script&lang=js&"
export * from "./sub_task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports